import API from "@services/root/rootApi";
import Axios from "axios";
import { Dispatch, SetStateAction } from "react";
import { Location } from "@services/locations/types";

export const resetLogo = async (objectId: string, logoClass: string) =>
  await API.post(
    `/symphony-api/provisioning/image/reset?logoClass=${logoClass}&objectId=${encodeURIComponent(
      objectId
    )}`
  );
export const uploadLogo = async (
  data: FormData,
  objectId: string,
  logoClass: string,
  setProgress?: Dispatch<SetStateAction<number>>,
  skipAudit?: boolean
) => {
  let extraparam = skipAudit ? "&skipAudit=true" : "";
  const response = await API.post(
    `/symphony-api/provisioning/image?logoClass=${logoClass}&objectId=${encodeURIComponent(
      objectId
    )}${extraparam}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.progress ?? 0) * 100;
        setProgress && setProgress(progress);
      },
    }
  );
  return response.data;
};

const user = "avisplsymphony";
const stylesheet = "clkwa6nk1004701pmfz5829h9";
const color = "#FF2020";
const zoom = 15;

export const getMapUrl = (long: number, lat: number) => {
  const coords = [long, lat];
  // example of working pin: "pin-s+FF2020(-77.08, 43.05)"
  const pin = `pin-s+${color.replace("#", "")}(${coords.join()})`;
  const mapPosition = [...coords, zoom].join();
  return `https://api.mapbox.com/styles/v1/${user}/${stylesheet}/static/${pin}/${mapPosition}/128x128?access_token=${__symphony_env__.REACT_APP_MAPBOX_TOKEN}`;
};
export const setDefaultLocationMapImage = async ({
  latitude,
  longitude,
  id,
}: Pick<Required<Location>, "latitude" | "longitude" | "id">) => {
  const data = (
    await Axios.get(getMapUrl(longitude, latitude), {
      responseType: "blob",
    })
  ).data;
  const formData = new FormData();
  formData.append("file", data);
  let path = await uploadLogo(
    formData,
    id,
    "Location",
    () => {}, // ProgressFn is most likely silent as nothing's listening to it,
    true
  );
  return `/symphony-api/provisioning/image/${path}`;
};
